import { LocaleKeys } from '../../../../locale/translation-types'

export enum PositionStatusEnum {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME'
}

export const positionStatusEnumMapping: Record<PositionStatusEnum, LocaleKeys> = {
  [PositionStatusEnum.FULL_TIME]: 'position.status.fullTime',
  [PositionStatusEnum.PART_TIME]: 'position.status.partTime'
}
